import React from 'react';
import {Skeleton} from 'antd';

function ContentSuspenseComponent(props){
	return(
		<>
			<Skeleton/>
		</>
	);
}

export default ContentSuspenseComponent;
